import { Node_Type } from "./../../ricos-types/index.js";
import VerticalEmbed from "./vertical-embed.js";
const nodeViewRenderers = {
  [Node_Type.APP_EMBED]: VerticalEmbed
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
